import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const apiBaseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.url.startsWith('http://') || request.url.startsWith('https://')) {
    return next(request);
  }

  const normalizedBaseUrl = environment.api.baseUrl.replace(/\/$/, '');
  const normalizedPath = request.url.startsWith('/') ? request.url : `/${request.url}`;
  return next(request.clone({ url: `${normalizedBaseUrl}${normalizedPath}` }));
};
